import {
  query,
  printPlugin,
  getprintPlugin,
  getType,
  modify,
  remove,
  getByType,
  debugPrinter
} from '@/services/wcs/Printplug';

export default {
  namespace: 'printplug',
  state: {
    data: {
      list: [],
      pagination: {},
    },
  },
  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success ) {
        yield put({
          type: 'save',
          payload: {
            list: response.data?response.data:[],
          },
        });
      }
      if (callback) callback(response);
    },
    *printPlugin({ payload, callback }, { call, put }) {
      const response = yield call(printPlugin, payload);
      if (callback) callback(response);
    },
    *getprintPlugin({ payload, callback }, { call, put }) {
      const response = yield call(getprintPlugin, payload);
      if (callback) callback(response);
    },
    *getType({ payload, callback }, { call, put }) {
      const response = yield call(getType, payload);
      if (callback) callback(response);
    },
    *getByType({ payload, callback }, { call, put }) {
      const response = yield call(getByType, payload);
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *remove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },
    *debugPrinter({ payload, callback }, { call, put }) {
      const response = yield call(debugPrinter, payload);
      if (callback) callback(response);
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload.list,
      };
    }
  }
};
